import React from "react";
import { Tag } from "antd";
import { MessageCircle, ShieldCheck, RefreshCw, Clock, Sparkles } from "lucide-react";

const LessonWaitingApprovalView = ({
  whatsappGroupUrl,
  onRefresh,
  refreshing,
  onReviewLessons,
  quizScore,
  totalPoints,
}) => {
  const officialGroupUrl =
    whatsappGroupUrl || "https://chat.whatsapp.com/G5oQ0H9qN0S7K8m2P4r1T3";
  const scoreVal = quizScore !== undefined && quizScore !== null ? Number(quizScore) : null;
  const totalVal = Number(totalPoints || 0);

  return (
    <div className="space-y-4 text-left">
      <div className="bg-white rounded-2xl p-5 md:p-6 text-center flex flex-col items-center border border-gray-100 shadow-sm">
        <div className="w-12 h-12 rounded-xl bg-gray-900 text-white flex items-center justify-center mb-3 shadow-xs">
          <Clock className="w-6 h-6 text-white" />
        </div>

        <div className="mb-3 flex items-center justify-center gap-2 flex-wrap">
          <span className="font-gilroyBold text-xs px-2.5 py-1 rounded-full bg-yellow-50 text-yellow-800 border border-yellow-200/80 uppercase tracking-wide">
            Status: Waiting for Approval
          </span>
          <span className="font-gilroyBold text-xs px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200/80 uppercase tracking-wide flex items-center gap-1">
            <ShieldCheck className="w-3.5 h-3.5 inline" /> Training Completed
          </span>
          {scoreVal !== null && (
            <span className="font-gilroyBold text-xs px-2.5 py-1 rounded-full bg-purple-50 text-purple-700 border border-purple-200/80 uppercase tracking-wide">
              Quiz Score: {totalVal > 0 ? `${scoreVal}/${totalVal} Points` : `${scoreVal} Points`}
            </span>
          )}
        </div>

        <h1 className="text-xl md:text-2xl font-gilroyBold text-gray-900 leading-tight mb-2 tracking-tight">
          Application Pending Approval
        </h1>

        <p className="text-gray-600 text-[13px] mb-4 max-w-xl leading-relaxed">
          You have submitted your application and completed the orientation training assessment! Your application is now in review by the Konnect admin team.
        </p>

        <div className="w-full bg-white border border-gray-100 rounded-2xl p-4 sm:p-5 text-left mb-4 shadow-sm space-y-3">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-emerald-600 text-white flex items-center justify-center flex-shrink-0 shadow-xs">
              <MessageCircle className="w-5 h-5" />
            </div>
            <div className="flex-1">
              <h2 className="font-gilroyBold text-[14px] text-gray-900 m-0">
                Join the Official WhatsApp Group
              </h2>
              <p className="text-gray-600 text-[13px] m-0 mt-0.5 leading-relaxed">
                Connect with our ambassador team, receive daily promotional announcements, and get fast-tracked onboarding assistance.
              </p>
            </div>
          </div>

          <a
            href={officialGroupUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white font-gilroyBold text-[13px] rounded-xl border-0 shadow-xs cursor-pointer flex items-center justify-center gap-2 transition no-underline"
          >
            <MessageCircle className="w-4 h-4" />
            <span>Join Ambassador WhatsApp Group</span>
          </a>
        </div>

        <div className="w-full bg-yellow-50 rounded-2xl p-4 text-left mb-4 border border-yellow-100/60 space-y-1.5">
          <div className="flex items-center gap-2 text-gray-900 font-gilroyBold text-[13px]">
            <Sparkles className="w-4 h-4 text-yellow-800 flex-shrink-0" />
            <span>What Happens Next?</span>
          </div>
          <p className="text-gray-600 text-[13px] m-0 leading-relaxed">
            Note: ONLY approved ambassadors will see the Performance page for Posting and Promo. Once an administrator approves your account, your full ambassador dashboard, daily promo tasks, and multiplier earnings will be unlocked automatically.
          </p>
        </div>

        <div className="w-full space-y-2.5">
          <button
            type="button"
            disabled={refreshing}
            onClick={onRefresh}
            className="w-full py-2.5 px-4 bg-white hover:bg-gray-50 text-gray-700 font-gilroyBold text-[13px] rounded-xl border border-gray-200 shadow-xs cursor-pointer transition-all flex items-center justify-center gap-2"
          >
            <RefreshCw className={`w-4 h-4 text-gray-600 ${refreshing ? "animate-spin" : ""}`} />
            <span>{refreshing ? "Checking Approval..." : "Check Approval Status"}</span>
          </button>

          {onReviewLessons && (
            <button
              type="button"
              onClick={onReviewLessons}
              className="w-full py-2 bg-transparent text-gray-600 hover:text-gray-900 font-gilroyBold text-[13px] border-0 cursor-pointer transition"
            >
              Review Lessons & Quiz
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default LessonWaitingApprovalView;
